import * as React from 'react'
import { Button, Form } from 'react-bootstrap'

import { copyObject } from '../../../../../utils'
import InputDatePicker from '../../../../../components/InputDatePicker'
import NumberFormatValidate from '../../../../../components/NumberFormatValidate'
import { VariableT, VariablesT, ListOptionsEstimate } from '../../../../../types/Company'
import * as _ from "lodash";
import { EstimateLineItemT } from '../../../../../types/Job'



interface EstimateLineItemProps {
    companyVariables: VariablesT
    lineItem: EstimateLineItemT
    index: number
    updateLineItem(key: string, value: any, index: number): void
    removeLineItem(index: number): void
    editable?: boolean
}

export const reflectorLabelsEstimate = (companyVariables: VariablesT, variable: VariableT, typeLable: 'rate' | 'units') => {
    let strLable = typeLable == 'rate' ? variable.rateLabel : variable.unitsLabel
    // search <key> if exists in rateLabel or unitsLabel
    const regex = /[<][a-z-A-Z]+[>]/g;
    let match = regex.exec(strLable)
    if (_.isArray(match) && match[0]) {
        let strMatch = String(match[0]).replace('<', '').replace('>', '');
        if (companyVariables[strMatch]) {
            // replace value for  related key by regex
            return strLable.replace(regex, companyVariables[strMatch].value)
        }
    }
    return typeLable == 'rate' ? variable.rateLabel : variable.unitsLabel;
}


const EstimateLineItem: React.FunctionComponent<EstimateLineItemProps> = ({ companyVariables, lineItem, index, updateLineItem, removeLineItem, editable }): JSX.Element => {

    //  renderLabel
    const renderLabel = (item: string, isRate: boolean = true): string => {
        if (companyVariables[item]) {
            return `, ${reflectorLabelsEstimate(companyVariables, companyVariables[item], isRate ? 'rate' : 'units')}`
        }
        return '';
    }

    const ItemsOptions = (): Array<JSX.Element> => {
        return ListOptionsEstimate.map((li, index) => {
            return <option value={li} key={index}>{companyVariables[li].verboseName}</option>
        })
    }

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' }}>
            <div>
                <Form.Label>Date</Form.Label>
                <InputDatePicker
                    disabled={!editable}
                    id={`estimate-date-${index}`}
                    className="input-material"
                    style={{ width: '100%' }}

                    selectedDate={`${lineItem.lineItemDate ? lineItem.lineItemDate : ""}`}
                    onChangeDate={(val) => {
                        updateLineItem('lineItemDate', val, index)

                    }}
                    onChange={(val) => {
                        // updateLineItem('lineItemDate', val, index)

                    }}
                    dateFormat="MM/dd/yyyy"
                    placeholder=""
                />
            </div>
            <div>
                <Form.Label>Item</Form.Label>
                <Form.Control
                    disabled={!editable}
                    as='select'
                    className='input-material'
                    onChange={(event: any): void => { updateLineItem('item', event.target.value, index) }}
                    value={`${lineItem.item}`}>
                    {ItemsOptions()}
                </Form.Control>
            </div>
            <div>
                <Form.Label>Rate{renderLabel(lineItem.item, true)}</Form.Label>
                <NumberFormatValidate
                    disabled={!editable}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${lineItem.rate}`}
                    value={`${lineItem.rate}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != lineItem.rate) {
                            updateLineItem('rate', floatValue, index)
                        }
                    }}
                    mask="_"
                    // prefix={'$'}
                    fixedDecimalScale={true}
                    decimalScale={2} />
            </div>
            <div>
                <Form.Label>Units{renderLabel(lineItem.item, false)}</Form.Label>
                <NumberFormatValidate
                    disabled={!editable}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${lineItem.units}`}
                    value={`${lineItem.units}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != lineItem.units) {
                            updateLineItem('units', floatValue, index)
                        }
                        // updateLineItem('units', floatValue, index)
                    }}
                    mask="_"
                    // prefix={'$'}
                    // allowLeadingZeros={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                // //allowNegative={false}
                // isNumericString={true}
                // thousandSeparator={true}

                />
            </div>
            <div>
                <Form.Label>Total, $</Form.Label>
                <Form.Control
                    className='input-material'
                    disabled
                    value={`${parseFloat(`${lineItem.total}`).toFixed(2)}`} />
            </div>
            <div onClick={(): void => { removeLineItem(index) }}> x </div>
        </div>

    )
}

export default EstimateLineItem
